import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { toastWarn } from "../../../common/Toast";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const DeletedSalesReport = (props) => {
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [saletype, setSaletype] = useState([]);
  const [tierid, settierid] = useState(0);
  const [customerDropdown, setcustomerDropdown] = useState([]);
  const [customerid, setcustomerid] = useState(0);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );
  const [totalData, setTotalData] = useState({
    TotalSum: 0,
    SubTotalSum: 0,
    TaxSum: 0,
    CostOfGoodsSoldSum: 0,
    ProfitSum: 0,
  });

  const [classicView, setClassicView] = useState(true);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleChangeCustomer = (event) => {
    console.log(event, "handleChangeCustomer");
    setcustomerid(event?.value);
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/deletedsales?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&customerid=${customerid}&saletype=${salesTypeID}&locationid=${selectedlocationid}&tierid=${tierid}&currentlocationid=${locationid}
          `,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          if (res.data.ResponseData.length > 0) {
            setTotalData({
              ...totalData,
              TotalSum: res.data.ResponseData[0].TotalSum,
              SubTotalSum: res.data.ResponseData[0].SubTotalSum,
              TaxSum: res.data.ResponseData[0].TaxSum,
              ProfitSum: res.data.ResponseData[0].ProfitSum,
            });
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
            setTotalData({
              ...totalData,
              TotalSum: 0,
              SubTotalSum: 0,
              TaxSum: 0,
              CostOfGoodsSoldSum: 0,
              ProfitSum: 0,
            });
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setcustomerDropdown(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        // setSaletype(response.data.ResponseData.filter((item) => item.ID !== 3));
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const Classiccolumns = [
    {
      title: "SaleId",
      field: "SaleId",
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "Type",
      field: "SaleType",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Location",
      field: "Location",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Date",
      field: "Date",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Item Purchased",
      field: "ItemPurchased",
      bottomCalc: "sum",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Deleted By",
      field: "DeletedBy",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Sold By",
      field: "SoldBy",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Sold To",
      field: "SoldTo",
      headerFilter: "input",
      defaultVisible: true,
    },
 {
      title: "Sub Total",
      field: "SubTotal",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total",
      field: "Total",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
       {
      title: "Tax",
      field: "Tax",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
      {
      title: "Profit",
      field: "Profit",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Payment Type",
      field: "PaymentType",
      headerFilter: "input",
    },
    {
      title: "Comments",
      field: "Comments",
      headerFilter: "input",
    },
  ];

  const columns = useMemo(() => [
    {
      header: "Sale Id",
      accessorKey: "SaleId",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Type",
      accessorKey: "SaleType",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Location",
      accessorKey: "Location",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Date",
      accessorKey: "Date",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) =>
        moment(row.original.Date).format("YYYY-MM-DD") === "Invalid date"
          ? ""
          : moment(row.original.Date).format(
              `${dateFormate.toUpperCase()} h:mm A`
            ),
    },
    {
      header: "Items Purchased",
      accessorKey: "ItemPurchased",
      filterFn: "contains",
    },
    {
      header: "Deleted By",
      accessorKey: "DeletedBy",
      filterFn: "contains",
    },
    {
      header: "Sold By",
      accessorKey: "SoldBy",
      filterFn: "contains",
    },
    {
      header: "Sold To",
      accessorKey: "SoldTo",
      filterFn: "contains",
    },
    {
      header: "Subtotal",
      accessorKey: "SubTotal",
      enableSorting: false,
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Subtotal = row?.original?.SubTotal;
        if (Subtotal == "0.00" || Subtotal == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Subtotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      enableSorting: false,
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const total = row?.original?.Total;
        if (total == "0.00" || total == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Tax",
      accessorKey: "Tax",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        // const tax = row?.original?.Tax;
        // if (tax == "0.00" || tax == "") {
        //   return 0.0;
        // } else {
        return (
          <div>
            {CurrencySymbols(
              Number(row?.original?.Tax),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      // },
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        // const profit = row?.original?.Profit;
        // if (profit == "0.00" || profit == "") {
        //   return 0.0;
        // } else {
        return (
          <div>
            {CurrencySymbols(
              Number(row?.original?.Profit),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
        // }
      },
    },
    {
      header: "Payment Type",
      accessorKey: "PaymentType",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Comments",
      accessorKey: "Comments",
      size: "120",
      filterFn: "contains",
    },
  ]);

  const handleChangeSalesType = (event) => {
    console.log(event, "handleChangeSalesType");
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  let dashStyle = {
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Deleted Sales Report</li>
              </ul>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-3">Customer</label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={customerDropdown.map((customer) => ({
                      label: customer.CompanyName,
                      value: customer.Id,
                    }))}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(e, index) => handleChangeCustomer(e, index)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Sale Type
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apiCall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.SubTotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.SubTotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Subtotal</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.TotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TaxSum} */}
                        {CurrencySymbols(
                          Number(totalData.TaxSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Tax</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.ProfitSum} */}
                        {CurrencySymbols(
                          Number(totalData.ProfitSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Profit</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">Deleted Sales Report</p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>
                    <div>
                      {ReportViewPermission == true ? (
                        <button
                          className="btn btn-secondary"
                          onClick={() => setClassicView(!classicView)}
                        >
                          {" "}
                          {classicView ? "Classic View" : "Morden View"}
                        </button>
                      ) : (
                        <></>
                      )}
                      {classicView ? (
                        <CommonTabular
                          Data={responseData}
                          columns={Classiccolumns}
                          Groupvalue={[]}
                          Reportname={"Deleted_Sales_Report"}
                          frozenRowvalue={0}
                          // layout={"fitDataFill"}
                          Onrefresh={() => apiCall()}
                        />
                      ) : (
                        <CommonMatrialReactTable
                          MainHeading="Sonar POS"
                          ReportHeading="Deleted Sale's"
                          columns={columns}
                          data={responseData}
                          startdate={startdate}
                          enddate={enddate}
                          columnGrouping={[]}
                          columnsVisibility={{}}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DeletedSalesReport;
